module.exports = __webpack_public_path__ + "media/stylesheets/images/martech_img-1dbf21a44efe483b2760b08202048e13.png";